<template>
  <div class="row">
    <div class="col-lg-8 col-xl-9 order-lg-1">
      <app-frame>
        <BasePlayer
          :id="`hero-${video.id}`"
          ref="player"
          ratio="16x9"
          :source="video.play_url || video.hls_url"
          :source-type="video.play_url ? 'video/mp4' : 'application/x-mpegURL'"
          :poster="getVideoPoster(video)"
          :track-playback="trackPlayback"
          :subtitles-en="video.subtitles_en"
          :subtitles-de="video.subtitles_de"
          :subtitles-fr="video.subtitles_fr"
          @send-playback="onSendPlayback"
        />
      </app-frame>
      <div class="video-label" v-html="statText"></div>
    </div>
    <div class="description-block col-lg-4 col-xl-3 order-lg-0">
      <h1 class="main-title">{{ getVideoTitle(video) }}</h1>
      <p>{{ getVideoDescription(video) }}</p>

      <div class="d-flex justify-content-center justify-content-lg-start">
        <button v-modal.modal-signup class="btn btn-primary wide" @click="sendRegistrationTrack">{{ ctaLabel || $t("Join Now") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import AppFrame from "@/components/v2/app-frame/index.vue";
import { getFreeareaVideoPoster } from "@/utils/mediaHelper";
import { amplitudeRegistrationButtonClickTrack, amplitudeTrack } from "@/utils/amplitude";
import BasePlayer from "@/components/player/BasePlayer.vue";

export default {
  name: "hero-item",
  components: { BasePlayer, AppFrame },
  props: {
    trackPlayback: {
      type: Boolean,
      default: false,
      required: false,
    },
    video: {
      type: Object,
      required: true,
    },
    ctaLabel: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    statText() {
      return this.$t("In our journey we've met <b>892 models</b>, made <b>6390+ videos</b> and had countless orgasms");
    },
  },
  methods: {
    sendRegistrationTrack() {
      amplitudeRegistrationButtonClickTrack("hero");
    },
    getVideoPoster(video) {
      return getFreeareaVideoPoster(video.thumb);
    },
    getVideoTitle(video) {
      return video["title_" + this.$root.$i18n.locale];
    },
    getVideoDescription(video) {
      return video["description_" + this.$root.$i18n.locale];
    },
    onSendPlayback(params) {
      if (!params) {
        return;
      }

      amplitudeTrack("Freearea video playback", params)
        .catch(() => {})
        .finally(() => {
          const player = this.$refs.player;

          if (player) {
            player.$data.log.playbackSent = true;
          }
        });
    },
  },
};
</script>
